<template>
<div style="display: flex;align-items: center;margin-top: 3%;justify-content: center">

  <el-card  class="introduction6" >
    <h1>说明文档</h1>
    <el-divider></el-divider>
    <h3 style="color: #409EFF">网站需要登录后使用，账号密码仅作为区分用户的标识，不具有其它效益，账号密码的注册仅支持英文字母数字及特殊字符</h3><br>
    <h2>育种目标：</h2>
    <p>1. 该模块为设计理想个体的第1步，请在完成育种目标的性状选择后再进行其它模块的筛选。</p>
    <p>2. 在设计理想个体选择性状时，必须要选择1个以上的性状，至多可以选择5个性状；在选择每个性状的具体指标时，最少要选择1个指标，至多可以选择6个指标。</p>
    <p>3. 在选择一个性状的各个指标后，点击提交按钮，进行下一个性状和指标的选择，直到完成全部性状的选择。</p><br>
    <h2>育种素材：</h2>
    <p>1. 该模块为设计理想个体的第2步，请在完成参考群体的选择之后再操作分子设计模块。</p>
    <p>2. 需要选择与育种目标相同的性状，并至少选择性状内的一个猪种，如：在育种目标中选择生产性状，则在参考群体也需要选择生产性状，并选择对应的猪种提交。</p>
    <p>3. 由于参考群体基因组文件较大，加载需要耗费一定的时间。</p>
    <h4>特别的说明：</h4>
    <p>对于生产性状，可以至多选择3个猪种，如可以同时选择二花脸、梅山猪及大白猪；</p>
    <p>对于肉质性状， 至多可以选择一个猪种作为参考群体，如当选择莱芜猪后，不能够再选择其它猪种；</p>
    <p>对于生产性状和胴体性状 可以选择至多3个猪种， 如可以同时选择大白猪、长白猪及杜洛克作为参考群体；</p>
    <p>对于外貌性状：西方品种可以自由选择，但是中国地方品种只能选择一个， 如可以选择杜洛克和长白猪作为参考群体，但此时不能够在选择其它品种，也可以选择地方品种，如选择莱芜猪，但此时不能够再选择其它猪种。</p><br>

    <h2>分子设计：</h2>
    <p>1. 请您在完成前面两步选择后，再进入此页面进行选择。</p>
    <p>2. 分子设计页面总包含6个小的模块，分别为上传文件，PLINK过滤，QTL注释、基因比对、一因多效检验及展示下载理想个体。</p>
    <p>3. 上传文件部分：该部分可以选择上传基因组文件，但上传文件的格式要求为vcf文件或者vcf.gz文件；如您的基因组数据位于我们的服务器中，
      可以输入其绝对路径，请将路径补充完整，如：/disk191/guojw/DDL_DDJ_DJ_JS_CJ/YGG/YGG.vcf。</p>
    <p>4. PLINK过滤部分：增加了可编辑的过滤条件，主要为maf、geno以及hwe，其中maf默认为0.01，geno默认为0.05，hwe默认为0.000001</p>
    <p>5. QTL注释：在完成PLINK过滤后进行此操作，可以修改interval，interval意为以给定基因标记或单体型坐标为中心，向上游和下游延伸一定的碱基对数目的区域，默认值为0，可修改为其它整数值，如100，200等 </p>
    <p>6. 基因比对：此操作进行QTL注释集合与参考群体基因比对操作，在进行这一步时，请务必确保育种目标和育种素材选择完成，否则会报错。 </p>
    <p>7. 一因多效检验：该操作会删除一个点影响多个性状的位点，此外还会完成添加主效基因的操作。</p>
    <p>8. 展示下载理想个体：点击“生成”按钮，会生成最终的理想个体，点击“展示”按钮，会展示每个性状前20个位点，点击“下载”按钮，将会获得所生成理想个体的MAP和PED文件。 </p><br>
    <h2>系祖选择：</h2>
    <p>1. 在设计完成理想个体之后，可以用不同性状的加和权重对个体进行选择。</p>
    <p>2. 请选择与育种目标和育种素材对应的性状，每个性状有默认值，并重新分配不同性状不同的权重。</p>
    <p>3. 在输入每个性状不同权重后点击提交，会获得当前列表所有个体的选择指数。</p>
    <p>4. 点击展示或者下载可以看到进行IBS加权计算后的结果。</p>
    <p style="margin-bottom: 5%"></p>
    <el-divider></el-divider>


    <h3 style="margin-top: 5%">如有任何关于网站使用的问题或者建议，请联系邮箱guojw@zju.edu.cn，感谢您对网站的支持！</h3>



  </el-card>
</div>
</template>

<script>
export default {
  name: "Documentation"
}
</script>

<style scoped>
.introduction5{
  width: 20%;
  height: 1425px;
  margin-bottom: 5%;
  margin-top: 1%;
  background-color: #fbfbfb;
  border:1px solid #d9d9d9;
  border-radius: 10px;

}
.introduction6{
  width: 60%;
  text-align: left;
  padding: 2%;
  margin-top: 1%;
  margin-bottom: 5%;
  margin-left: 1%;
  background-color: #fbfbfb;
  border:1px solid #d9d9d9;
  border-radius: 10px;
}


</style>